export default function (evt) {
    let window = 'aberturacotacao'
    !this.$uloc.window.get(window) && this.$uloc.window.new({
        wid: window,
        title: 'Abertura de Cotação para Remoção',
        width: '80%',
        height: '90%',
        minHeight: '500px',
        maxWidth: '900',
        backdrop: true,
        clickOutside: false,
        windowClass: 'erp-window',
        contentClass: 'overflow-hidden',
        props: {cliente: this.cliente}
    }, () => import('../components/window/CotacaoRemocao.vue'))
        .then((wid) => {
            console.log(wid)
        }) // return wid
}
